<template>
  <main role="main" class="d-flex flex-column" style="min-height:100vh;background-color:#f0f1f7">

    <div style="flex:1 1 auto">

      <!-- Navigation -->
      <page-header nav="4"></page-header>
      <!-- Navigation -->

      <!-- Body -->
      <div class="container my-5">
        <div class="row justify-content-center">
          <div class="col-12 col-md-8 col-lg-6">

            <!--SIGNUP TAB-->
            <div class="card">
              <div class="card-header text-center">
                <b>LOGIN</b>
              </div>
              <div class="card-body">

                <!--SOCIALS-->
                <div class="p-0 mb-4">
                  <a id="button_login_google" class="btn btn-block btn-lg text-white text-center text-nowrap" style="background-color:#438bcb;padding:8px;font-size:0.95em" href="javascript:;" @click="loginGoogle">
                      <div style="display:inline-block;width:24px"><i class="fab fa-google-plus-g fa-fw"></i></div>
                      Sign in with Google
                  </a>
                </div>
                <!--SOCIALS-->

                <!--EMAIL SIGNUP-->
                <form>
                  <div class="mb-3">
                    <b>Your Email Address</b>
                    <input ref="ref_account_register_email" @keyup="emailEnterKey" id="text_account_register_email" type="email" class="form-control mt-2" v-model="account_register_email" maxlength="50" style="box-shadow:none" placeholder="Your name or email address" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off">
                  </div>
                  <div class="mb-2">
                    <div class="d-flex justify-content-between">
                      <b>Password</b>
                      <a href="javascript:;" class="text-muted" @click="forgotClicked">Forgot password?</a>
                    </div>
                    <input ref="ref_account_register_password" @keyup="passwordEnterKey" id="text_account_register_password" type="password" class="form-control mt-2" v-model="account_register_password" maxlength="30" style="box-shadow:none" placeholder="Password" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off">
                  </div>
                </form>
                <!--EMAIL SIGNUP-->

              </div>
              <div class="card-footer py-3">

                <button id="button_register" type="button" class="btn btn-primary btn-lg w-100" @click="loginClicked" style="position:relative;height:64px;overflow:hidden">
                  <div style="position:absolute;right:12px;bottom:-8px;color:#ffffff;opacity:0.25;">
                    <img src="/images/landing/robot-happy.svg" width="70" height="70"/>
                  </div>
                  <div style="position:absolute;left:12px;bottom:-13px;color:#ffffff;opacity:0.25;">
                    <img src="/images/landing/robot-arm.svg" width="70" height="70"/>
                  </div>
                  <b>Login</b>
                </button>

                <div class="mt-3 text-center">
                  <router-link tag="a" class="text-muted" :to="{name:'Signup',params:{email:account_register_email}}">Need to create an new account?</router-link>
                </div>
                <div class="mt-0 text-center">
                  <router-link tag="a" class="text-muted" :to="{name:'EmailVerification',params:{email:account_register_email}}">Got an email verification code?</router-link>
                </div>
                <div class="mt-0 text-center">
                  <router-link tag="a" class="text-muted" :to="{name:'LoginStudent'}">Are you a student with a login code?</router-link>
                </div>
              </div>
            </div>
            <!--SIGNUP TAB-->

          </div>
        </div>
      </div>
      <!-- Body -->
    </div>

    <!-- Footer -->
    <page-footer></page-footer>
    <!-- Footer -->

  </main>
</template>

<script>
  import PageHeader from '../components/PageHeader.vue';
  import PageFooter from '../components/PageFooter.vue';
  import Common from '../mixins/Common'

  export default {

    props: {
      email:String
    },

    mixins: [Common],

    components: {PageHeader,PageFooter},

    data() {
      return {
        account_register_email: '',
        account_register_password: '',
      }
    },

    created() {
      app = this;
    },

    mounted() {
      document.title = 'PCB Preflight Login';

      //Get email
      let email = this.email || this.$route.query.email || '';
      if(!this.validateEmail(email)) {
        this.account_register_email = '';
        this.$refs.ref_account_register_email.focus();
      }
      else {
        this.account_register_email = email;
        this.$refs.ref_account_register_password.focus();
      }

      //Check errors?
      if(this.$route.query.cd=='email-change-fail') {
        this.$eventHub.$emit('ok-modal',{title:'Email Verification Failed',message:"The verification link may have expired.  Please try changing your email again."});
      }
      else if(this.$route.query.cd=='login-required') {
        this.$eventHub.$emit('ok-modal',{title:'Login Required',message:"Login required to access the members area."});
      }
      else if(this.$route.query.cd=='g-err') {
        this.$eventHub.$emit('ok-modal',{title:'Google Login Failed',message:`This email already has a PCB Preflight account.<br/>Contact: <a href="mailto:support@pcbpreflight.com">support@pcbpreflight.com</a>.`});
      }
    },

    methods: {

      emailEnterKey(e) {
        if(e.keyCode!=13) return;
        this.$refs.ref_account_register_password.focus();
      },

      passwordEnterKey(e) {
        if(e.keyCode!=13) return;
        this.loginClicked();
      },

      loginFacebook() { //MUST BE PRETAMENU DOMAIN, DONT CHANGE!!
        this.$eventHub.$emit('loading',true);
        window.location = '/api/v1/oauth/facebook';
      },

      loginTwitter() { //MUST BE PRETAMENU DOMAIN, DONT CHANGE!!
        this.$eventHub.$emit('loading',true);
        window.location = '/api/v1/oauth/twitter';
      },

      loginGoogle() { //MUST BE PRETAMENU DOMAIN, DONT CHANGE!!
        this.$eventHub.$emit('loading',true);
        window.location = '/api/v1/oauth/google';
      },

      loginClicked() {
        if(this.account_register_email.length==0) return this.$eventHub.$emit('ok-modal',{title:'Login Error',message:"Please enter your email address."});
        else if(!this.validateEmail(this.account_register_email)) return this.$eventHub.$emit('ok-modal',{title:'Login Error',message:"Please enter a valid email address."});
        else if(this.account_register_password.length==0) return this.$eventHub.$emit('ok-modal',{title:'Login Error',message:"Please enter a password."});
        else if(this.account_register_password.length<6) return this.$eventHub.$emit('ok-modal',{title:'Login Error',message:"Please enter a password of atleast 6 characters."});

        let cb = () => {
          this.$eventHub.$emit('loading',true);
          let params = {
            email: this.account_register_email,
            password: this.account_register_password
          };
          let url = `${this.getApiUrl()}/api/v1/email/login`;
          $.post(url,params).done(response => {
            if(response.ok==0) {
              this.$eventHub.$emit('loading',false);
              if(response.err.message==null) return this.$eventHub.$emit('ok-modal',{title:'Registration Error',message:"Could not login please check your entries and try again."});
              else return this.$eventHub.$emit('ok-modal',{title:'Login Error',message:response.err.message});
            }
            else {
              this.account_register_email = '';
              this.account_register_password = '';
              window.location = '/admin';
            }
          }).fail((xhr,status,err)=>{
            this.$eventHub.$emit('loading',false);
            this.$eventHub.$emit('ok-modal',{title:this.$t("connection_error_title"),message:this.$t("connection_error_message")});
          });
        }

        //Email sanity check for gmail and yahoo
        if((this.account_register_email.indexOf('@gmail')>0||this.account_register_email.indexOf('@yahoo')>0) && !this.account_register_email.endsWith('.com')) {
          this.$store.commit('confirmModal',{title:'Email Check',message:`You typed your email as <kbd>${this.account_register_email}</kbd>  Please confirm if the email is correct?`,callback:cb});
        }
        else cb();
      },

      // Only emails can be forgotten
      forgotClicked() {
        if(this.account_register_email.length==0) return this.$eventHub.$emit('ok-modal',{title:'Forgot your Password',message:"Please enter your email address that you used to signup."});
        else if(!this.validateEmail(this.account_register_email)) return this.$eventHub.$emit('ok-modal',{title:'Forgot your Password',message:"Please enter a valid email address."});

        let cb = () => {
          this.$eventHub.$emit('loading',true);
          let params = {
            email: this.account_register_email
          };
          let url = this.getApiUrl();
          $.post(`${url}/api/v1/email/forgot`,params).done(response => {
            this.$eventHub.$emit('loading',false);
            if(response.ok==0) {
              if(response.err.message==null) return this.$eventHub.$emit('ok-modal',{title:'Forgot your Password',message:"Could not send a forgot password email, please check your entries and try again."});
              else return this.$eventHub.$emit('ok-modal',{title:'Forgot your Password',message:response.err.message});
            }
            else {
              this.account_register_password = '';
              this.$eventHub.$emit('ok-modal',{title:'Forgot Password',message:"We sent you an email with your new password.  You should receive it in a few minutes, then enter it here."});
            }
          }).fail((xhr,status,err)=>{
            this.$eventHub.$emit('loading',false);
            this.$eventHub.$emit('ok-modal',{title:this.$t("connection_error_title"),message:this.$t("connection_error_message")});
          });
        }

        //Email sanity check for gmail and yahoo
        if((this.account_register_email.indexOf('@gmail')>0||this.account_register_email.indexOf('@yahoo')>0) && !this.account_register_email.endsWith('.com')) {
          this.$eventHub.$emit('confirm-modal',{title:'Email Check',message:`You typed your email as ${this.account_register_email}    Please confirm if the email is correct?`,callback:cb});
        }
        else {
          this.$eventHub.$emit('confirm-modal',{title:'Forgot Password',message:`Would you like us to email you a new password to ${this.account_register_email}?  You will receive an auto-generated email with password that you can change later.`,callback:cb});
        }
      }

    }

  }
</script>
